import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  GradeBasis,
  IMaterialAuditEntry,
  IMaterialDelivery,
  IMaterialReceiptSlice,
} from 'types/materialReceipt.interface'
import { now, seedAudit, seedDeliveries } from 'pages/MaterialReceipt/materialReceiptData'

// Front-end mock store (greenfield — no backend yet). Structured so the seed/reducers can be
// replaced by createAsyncThunk + API calls later without touching the pages.
const initialState: IMaterialReceiptSlice = {
  deliveries: seedDeliveries(),
  auditLog: seedAudit(),
  config: { basis: 'DRY', threshold: 20 },
}

const materialReceiptSlice = createSlice({
  name: 'materialReceipt',
  initialState,
  reducers: {
    patchDelivery: (state, action: PayloadAction<{ id: string; fields: Partial<IMaterialDelivery> }>) => {
      const { id, fields } = action.payload
      state.deliveries = state.deliveries.map((d) => (d.id === id ? { ...d, ...fields } : d))
    },
    addDelivery: (state, action: PayloadAction<IMaterialDelivery>) => {
      state.deliveries = [action.payload, ...state.deliveries]
    },
    logAudit: (state, action: PayloadAction<Omit<IMaterialAuditEntry, 'id' | 'at'> & { at?: string }>) => {
      state.auditLog = [
        { id: state.auditLog.length + 1, at: action.payload.at || now(), ...action.payload },
        ...state.auditLog,
      ]
    },
    setBasis: (state, action: PayloadAction<GradeBasis>) => {
      state.config.basis = action.payload
    },
    setThreshold: (state, action: PayloadAction<number>) => {
      state.config.threshold = action.payload
    },
  },
})

export const { patchDelivery, addDelivery, logAudit, setBasis, setThreshold } = materialReceiptSlice.actions
export default materialReceiptSlice.reducer
